exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".search-input.widget {\n    display: flex;\n}\n\n.search-input.widget input {\n  flex: 1;\n  background-color: #FFFFFF;\n  border-color: #FFFFFF;\n  border-width: 0;\n  border-style: none;\n  box-sizing: border-box;\n  box-shadow: inset 0px 0px 4px 0px rgba(0, 0, 0, 0.2);\n}\n\n.search-input.widget input:focus {\n\n}\n\n.search-input.widget button {\n    width: 24px;\n    background: none;\n    padding: 0;\n    margin: 0;\n}\n\n.search-input.widget button:hover {\n    background-color: none;\n}\n\n.search-input.widget button > i.fa {\n    font-size: 17px;\n}\n\n.search-input.widget button > i.fa {\n    color: #9E9E9E;\n}\n\n.search-input.widget button:hover > i.fa {\n    color: #444444;\n}\n\n.search-input.widget .toolbar {\n    display: flex;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/app/widget/search-input/search-input.css
// module id = 535
// module chunks = 0